import { useMutation, useApolloClient } from "@apollo/client";

import { LOGIN_CUSTOMER_PORTAL, CURRENT_USER_QUERY } from "#/src/api";
import { base64String } from "#/src/utils";

export interface LoginCredentials {
  email: string;
  password: string;
  organizationId: string;
  signInToken?: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  redirectUrl: string;
  message: string;
  isError: boolean;
}

export const useLoginPortal = () => {
  const [submitLogin] = useMutation(LOGIN_CUSTOMER_PORTAL);
  const client = useApolloClient();

  const login = async (
    credentials: LoginCredentials,
    {
      onSuccess,
      onError,
    }: {
      onSuccess: (data: LoginResponse) => void;
      onError: (error: Error) => void;
    },
  ) => {
    try {
      const { data } = await submitLogin({
        mutation: LOGIN_CUSTOMER_PORTAL,
        variables: {
          userCredentials: {
            username: credentials.email,
            password: base64String(credentials.password),
            organization: credentials.organizationId,
            signInToken: credentials.signInToken,
          },
        },
      });
      if (data?.loginCustomerPortal) {
        await client.refetchQueries({
          include: [CURRENT_USER_QUERY],
        });
        onSuccess(data.loginCustomerPortal);
      } else {
        onError(new Error("Login failed"));
      }
    } catch (error) {
      onError(error as Error);
    }
  };

  return {
    login,
  };
};
